import { server } from '../helpers';

export const getValueCardData = (id: number, slug: string) => {
  const uriSlug = encodeURIComponent(slug);
  return server.request
    .get(`/places/${id}/valuecarddata?slug=${uriSlug}`)
    .then(server.handleSuccess)
    .catch(server.handleError);
};
